module.exports = __webpack_public_path__ + "img/jiaoliuxinxiang.ad09b20a.png";